<template>
    <div class="relatorio-analitico">
        <RelatorioAnaliticoComponentList
            app_modulo="promotor"
            app_submodulo="relatorio-analitico"
            app_tela="relatorio-ruptura"
            :objectList="rupturaList"
            :objectListAll="rupturaListAll"
            :isEmpty="isEmpty"
            :isLoading="isLoading"
            :isDataStarted="isDataStarted"
            :pagination="pagination"
            tooltipLabelSearch="msg-busca-ruptura"
            showLateralFilter
            :cameFrom="cameFrom"
            @filtersReset="filtersReset = $event"
            @loadedFiels="loadedFiels = $event"
            @carregarDados="carregarDados($event)"
            @carregarDadosExportAll="carregarDados($event, true)"
            @search="onSearch($event)"
            @clearFilter="clearFilter()"
            @orderColumn="pagination.orderColumn = $event"
            @orderDirection="pagination.orderDirection = $event"
            @perPage="pagination.perPage = $event"
            @currentPage="pagination.currentPage = $event"
            @isLoading="isLoading = $event"
            @voltar="$emit('voltar', $event)"
        >
            <template v-slot:top-filter>
                <vss-select
                    title="empresa"
                    ref="empresaSelect"
                    class="smaller"
                    :value="empresaSelected"
                    :options="empresaList"
                    :height="40"
                    :loading="empresaLoading"
                    @search="carregarEmpresas"
                    @input="updateEmpresa"
                    label="rsocial"
                    :closeOnSelect="false"
                    no-clearfix
                    multiple
                    clearable
                    searchable
                >
                    <template #multiple-selected="{ selected }">
                        ({{ selected && selected.length > 0 ? selected.length : $t('todos') }})
                    </template>
                </vss-select>
                <vss-select
                    title="colaborador"
                    ref="colaboradorSelect"
                    class="smaller"
                    :value="colaboradorSelected"
                    :options="colaboradorList"
                    :height="40"
                    :loading="colaboradorLoading"
                    @search="carregarColaboradores"
                    @input="updateColaborador"
                    label="nome"
                    :closeOnSelect="false"
                    no-clearfix
                    multiple
                    clearable
                    searchable
                    tooltipLabel="msg-associacao-empresa-colaborador"
                >
                    <template #multiple-selected="{ selected }">
                        ({{ selected && selected.length > 0 ? selected.length : $t('todos') }})
                    </template>
                </vss-select>
            </template>

            <template v-slot:table-column="{ props, field }">
                <div v-if="field.key === 'foto'">
                    <div @click="props.row.foto ? showFotosModal(props.row.id) : null">
                        <b-icon
                            :class="{ 'is-clickable': props.row.foto }"
                            pack="fas"
                            icon="image"
                            :type="props.row.foto ? 'is-primary' : 'is-gray'"
                        />
                    </div>
                </div>
                <div v-else>
                    {{ isNull(props.row[field.key]) ? '---' : props.row[field.key] }}
                </div>
            </template>

            <template v-slot:footer>
                <div v-if="loadedFiels" class="totalizador totalizador-columns">
                    <div>
                        <label>{{ $t('qtde-itens') }}:</label>
                        {{ pagination.totalRows }}
                    </div>
                    <div>
                        <label>{{ $t('qtde-troca') }}:</label>
                        {{ qtdeTroca }}
                    </div>
                    <div>
                        <label>{{ $t('qtde-area-venda') }}:</label>
                        {{ qtdeAreaVenda }}
                    </div>
                    <div>
                        <label>{{ $t('qtde-deposito') }}:</label>
                        {{ qtdeDeposito }}
                    </div>
                </div>
            </template>

            <template v-slot:lateral-filter>
                <FiltroRuptura
                    ref="filtroRef"
                    :filtersReset="filtersReset"
                    @update-filtro="updateFiltro"
                />
            </template>
        </RelatorioAnaliticoComponentList>
        
        <lateral-content
            :title="$t('fotos')"
            :isLoading="isLoadingFotos"
            v-model="showFotos"
            v-if="showFotos"
            header
        >
            <LateralContentFoto
                :fotosToDisplay="fotosToDisplay"
            />
        </lateral-content>
    </div>
</template>

<script>
import RelatorioAnaliticoComponentList from '@/components/shared/tela/RelatorioAnaliticoComponentList.vue';
import FiltroRuptura from '@/components/promotor/relatorio-analitico/relatorio-ruptura/RelatorioRupturaListFiltro.vue';
import LateralContentFoto from '@/components/shared/tela/LateralContentFoto.vue';

export default {
    components: {
        RelatorioAnaliticoComponentList,
        FiltroRuptura,
        LateralContentFoto
    },
    props: {
        cameFrom: {
            type: String,
            default: 'route',
        },
        idFrom: {
            type: Number,
            default: 0,
        },
        reloadData: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            rupturaList: [],
            rupturaListAll: [],

            filtros: {
                idEmpresaList: [],
                idVendedorList: [],
                dataInicial: new Date(this.$moment().subtract(30, 'days')),
                dataFinal: new Date(),
                idClienteList: [],
                idLpsList: [],
                idProdutoList: [],
                withTroca: 0,
                withDeposito: 0,
                withAreaVenda: 0,
                withFoto: 0,
                withRuptura: 0,
            },

            pagination: {
                resetPagination: false,
                perPageOptions: [10, 25, 50, 100],
                optionStarted: 0,
                perPage: null,
                totalRows: 0,
                currentPage: 1,
                orderColumn: 'idatendimentorupturaerp',
                orderDirection: 'asc',
                queryFilter: '.*',
            },

            empresaList: [],
            empresaSelected: [],
            empresaLoading: false,

            colaboradorList: [],
            colaboradorSelected: [],
            colaboradorLoading: false,

            isLoading: false,
            loadedFiels: false,

            qtdeTroca: 0,
            qtdeAreaVenda: 0,
            qtdeDeposito: 0,
            isEmpty: true,
            filtersReset: false,

            showFotos: false,
            isLoadingFotos: false,
            fotosToDisplay: [],
            isDataStarted: false,
        };
    },
    watch: {
        reloadData(val) {
            if (val) this.carregarDados(this.pagination.currentPage);
        },
    },
    created() {
        this.pagination.perPage = this.pagination.perPageOptions[this.pagination.optionStarted];
    },
    methods: {
        resetQtdeTroca() {
            this.qtdeTroca = 0;
        },
        resetQtdeAreaVenda() {
            this.qtdeAreaVenda = 0;
        },
        resetQtdeDeposito() {
            this.qtdeDeposito = 0;
        },
        onSearch(value) {
            this.pagination.queryFilter = value;
            this.carregarDados();
        },
        carregarDados(currentPage = 1, getAll = false) {
            if (!getAll && currentPage == 1 && this.pagination.currentPage != 1) {
                this.pagination.resetPagination = true;
            }
            if (!getAll) {
                this.resetQtdeTroca();
                this.resetQtdeAreaVenda();
                this.resetQtdeDeposito();
            }

            if (!getAll) this.rupturaListAll = [];

            this.isLoading = true;
            this.$axios
                .post(`pro/relatorio/ruptura/list.json`, this.filtros, {
                    params: {
                        column: this.pagination.orderColumn,
                        order: this.pagination.orderDirection,
                        page: currentPage - 1,
                        limit: getAll ? this.pagination.totalRows : this.pagination.perPage,
                        search: this.pagination.queryFilter,
                    },
                })
                .then((response) => {
                    if (!getAll) {
                        this.isEmpty = response.data.totalElements == 0;
                        this.pagination.totalRows = response.data.totalElements;
                    }

                    return response.data.content.map((obj) => {
                        if (!getAll) {
                            this.qtdeTroca = this.sumQtdeTotalizers(
                                this.qtdeTroca,
                                obj.troca
                            );
                            this.qtdeAreaVenda = this.sumQtdeTotalizers(
                                this.qtdeAreaVenda,
                                obj.area_venda
                            );
                            this.qtdeDeposito = this.sumQtdeTotalizers(
                                this.qtdeDeposito,
                                obj.deposito
                            );
                        }

                        const trocaValue = this.verifyFieldsByTipoCampo(
                            obj.troca,
                            obj.tipo_campo
                        );
                        const areaVendaValue = this.verifyFieldsByTipoCampo(
                            obj.area_venda,
                            obj.tipo_campo
                        );
                        const depositoValue = this.verifyFieldsByTipoCampo(
                            obj.deposito,
                            obj.tipo_campo
                        );

                        const houve_ruptura = this.getHouveRuptura(obj.ruptura);

                        return {
                            ...obj,
                            cliente_situacao:
                                obj.cliente_situacao === 3 ? this.$t('ativo') : this.$t('inativo'),
                            lps_situacao: obj.lps_situacao === 3 ? this.$t('ativo') : this.$t('inativo'),
                            datahora: this.$moment(obj.datahora).format('L LT'),
                            houve_ruptura: houve_ruptura,
                            troca: trocaValue,
                            area_venda: areaVendaValue,
                            deposito: depositoValue,
                        };
                    });
                })
                .then((mappedContent) => {
                    if (getAll) {
                        this.rupturaListAll = mappedContent;
                    } else {
                        this.rupturaList = mappedContent;
                    }
                })
                .catch((exception) => {
                    console.error('Erro ao carregar rupturas.', exception);
                    this.isEmpty = true;
                    this.$root.showMessage('error', 'msg-erro-dados-geral');
                })
                .finally((_) => {
                    this.pagination.resetPagination = false;
                    this.isDataStarted = true;
                    if (this.loadedFiels) this.isLoading = false;
                });
        },
        verifyFieldsByTipoCampo(field, tipoCampo) {
            if(tipoCampo === 1) {
                return field > 0 ? this.$t('sim') : this.$t('nao');
            }

            return field;
        },

        sumQtdeTotalizers(qtde, field) {
            const isValid = !this.isNull(field) && !this.isNull(qtde);
            const fieldNumber = Number(field);
            const fieldQtde = Number(qtde);
            let value = fieldQtde;

            if (isValid) {
                if (fieldNumber === 1) {
                    value = fieldQtde + 1;
                } else if (fieldNumber > 1) {
                    value = fieldQtde + fieldNumber;
                }
            }

            return value;
        },
        getHouveRuptura(ruptura) {
            let houve_ruptura;
            switch (ruptura) {
                case 1:
                    houve_ruptura = this.$t('sim');
                    break;
                case 0:
                    houve_ruptura = this.$t('nao');
                    break;
                case -1:
                    houve_ruptura = '---';
                    break;
                default:
                    houve_ruptura = ruptura;
            }   
            return houve_ruptura;
        },
        carregarEmpresas(search = '') {
            this.empresaLoading = true;
            this.$axios
                .get(`/vendas/empresa/list.json?param=${search}`)
                .then((response) => {
                    if (response.status != 200) {
                        console.error(`[RUPTURA] Erro status ${r.status} ao carregar empresas.`);
                        console.error(`[RUPTURA] Mensagem: ${r.message}`);
                    } else {
                        this.empresaList = response.data.content.map((e) => {
                            return {
                                id: e.idempresa,
                                rsocial: e.rsocial,
                            };
                        });
                    }
                })
                .catch((e) => {
                    this.empresaList = [];
                    console.error('[RUPTURA] Erro ao carregar empresas.', e);
                })
                .finally((_) => {
                    this.empresaLoading = false;
                });
        },
        updateEmpresa(empresa) {
            this.empresaSelected = empresa;

            this.colaboradorSelected = [];
            this.colaboradorList = [];

            this.filtros.idEmpresaList =
                this.empresaSelected.length == 0 ? [] : this.empresaSelected.map((e) => e.id);

            this.carregarColaboradores('');
            this.carregarDados();
        },
        carregarColaboradores(search = '') {
            this.colaboradorLoading = true;

            const empresa =
                this.empresaSelected.length > 0 ? this.empresaSelected.map((e) => e.id) : [];

            this.$axios
                .post(`/employees/list/associacaoidsempresa.json?search=${search}`, empresa)
                .then((response) => {
                    if (response.status != 200) {
                        console.error(
                            `[RUPTURA] Erro status ${r.status} ao carregar colaboradores.`
                        );
                        console.error(`[RUPTURA] Mensagem: ${r.message}`);
                    } else {
                        this.colaboradorList = response.data.content;
                    }
                })
                .catch((e) => {
                    this.empresaList = [];
                    console.error('[RUPTURA] Erro ao carregar colaboradores.', e);
                })
                .finally((f) => {
                    this.colaboradorLoading = false;
                });
        },
        updateColaborador(colaborador) {
            this.colaboradorSelected = colaborador;

            this.filtros.idVendedorList =
                this.colaboradorSelected.length == 0
                    ? []
                    : this.colaboradorSelected.map((e) => e.id);

            this.carregarDados();
        },
        clearFilter() {
            this.pagination.queryFilter = '.*';
            
            this.filtros.idEmpresaList = [];
            this.empresaSelected = [];

            this.filtros.idVendedorList = [];
            this.colaboradorSelected = [];

            this.filtros.dataInicial = new Date(this.$moment().subtract(30, 'days'));
            this.filtros.dataFinal = new Date();
            this.filtros.idClienteList = [];
            this.filtros.idLpsList = [];
            this.filtros.idProdutoList = [];
            this.filtros.withTroca = 0;
            this.filtros.withDeposito = 0;
            this.filtros.withAreaVenda = 0;
            this.filtros.withFoto = 0;
            this.filtros.withRuptura = 0;

            setTimeout(() => {
                this.carregarDados();
            }, 1000);
        },
        updateFiltro(filtro) {
            this.filtros[filtro.nomeFiltro] = filtro.valor;
        },
        showFotosModal(idRuptura) {
            this.isLoadingFotos = true;

            this.fotosToDisplay = [];

            this.$axios
                .get(`pro/relatorio/vencimento/${idRuptura}/fotos.json`)
                .then((response) => {
                    this.fotosToDisplay = response.data.content;
                })
                .catch((error) => {
                    console.error('Erro ao carregar fotos.', error);
                    this.$root.showMessage('error', 'msg-erro-dados-geral');
                })
                .finally((_) => (this.isLoadingFotos = false));

            this.showFotos = true;
        },
    },
};
</script>

<style lang="scss" scoped>
.relatorio-analitico {
    height: 100%;
}

.totalizador {
    background-color: #f9f9f9;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
    opacity: 0.7;
    border-radius: 6px;
    display: flex;
    justify-content: space-between;
    & > div {
        padding: 10px;
        label {
            color: $sovis-black;
            font-size: 1em;
            padding-right: 10px;
        }
        @media screen and (max-width: 750px) {
            padding: 2px 10px;
        }
    }
    @media screen and (max-width: 750px) {
        flex-direction: column;
    }
}
</style>
